import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { PasswordModule } from 'primeng/password';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from "primeng/message"; 
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { InputOtpModule } from 'primeng/inputotp';
import { TranslocoRootModule } from '../../transloco-root.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../../app-routing.module';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AccountComponent } from './account/account.component';
import { DashboardTemplateComponent } from '../dashboard/dashboard-template/dashboard-template.component';
import { TabMenuModule } from 'primeng/tabmenu';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SharedModule} from '../../share/share.module';
import { MfaLoginComponent } from './mfa-login/mfa-login.component';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { DialogModule } from 'primeng/dialog';
import { SkeletonModule } from 'primeng/skeleton';
import { StorageFormatPipe } from 'src/app/share/pipes/storageFormat.pipe';
import { ProFeatureModalComponent } from 'src/app/share/pro-feature-modal/pro-feature-modal.component';
import { PasswordStrengthChecklistComponent } from 'src/app/share/password-strength-checklist/password-strength-checklist.component';
import { DigitOnlyDirective } from 'src/app/share/directives/digit-only.directive';
import { DateOnlyDirective } from 'src/app/share/directives/date-only.directive';
import { AvatarCropperComponent } from 'src/app/shared/avatar-cropper/avatar-cropper.component';
import { InvoiceDetailModalComponent } from 'src/app/share/invoice-detail-modal/invoice-detail-modal.component';
import { InvoiceListPanelComponent } from 'src/app/share/invoice-list-panel/invoice-list-panel.component';
import { TokenPurchaseModalComponent } from 'src/app/share/token-purchase-modal/token-purchase-modal.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { LoginSceneComponent } from './login/login-scene/login-scene.component';
import { AccountDeletionComponent } from './account-deletion/account-deletion.component';
import { AccountDeletionPendingComponent } from './account-deletion/account-deletion-pending.component';
import { DataExportComponent } from './data-export/data-export.component';

@NgModule({
  declarations: [
    LoginComponent,
    CreateAccountComponent,
    ActivateAccountComponent,
    ForgotPasswordComponent,
    AccountComponent,
    MfaLoginComponent,
    AuthCallbackComponent,
    AccountDeletionComponent,
    AccountDeletionPendingComponent,
    DataExportComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    InputTextModule,
    InputGroupModule,
    InputGroupAddonModule,
    PasswordModule,
    ButtonModule,
    MessagesModule,
    MessageModule,
    ReactiveFormsModule,
    DropdownModule,
    CalendarModule,
    InputMaskModule,
    SelectButtonModule,
    TranslocoRootModule,
    HttpClientModule,
    CheckboxModule,
    InputOtpModule,
    DashboardTemplateComponent,
    TabMenuModule,
    InputSwitchModule,
    TooltipModule,
    ToastModule,
    ConfirmDialogModule,
    TableModule,
    ProgressSpinnerModule,
    SharedModule,
    DialogModule,
    SkeletonModule,
    ProFeatureModalComponent,
    PasswordStrengthChecklistComponent,
    DigitOnlyDirective,
    DateOnlyDirective,
    AvatarCropperComponent,
    InvoiceDetailModalComponent,
    InvoiceListPanelComponent,
    TokenPurchaseModalComponent,
    LoginSceneComponent,
    AuthLayoutComponent,
    NgxMaskDirective,
  ],
  exports: [
    LoginComponent,
    CreateAccountComponent,
    ActivateAccountComponent,
    ForgotPasswordComponent,
    AccountComponent,
    MfaLoginComponent,
    AuthCallbackComponent,
    AccountDeletionComponent,
    AccountDeletionPendingComponent,
    DataExportComponent,
  ],
  providers: [provideAnimations(), provideNgxMask() , provideAnimationsAsync(), MessageService]
})
export class UserModule { }
